export default __webpack_public_path__ + "static/media/firstDance.eb913830.jpg";